/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBracketsContain = createReactComponent("outline", "brackets-contain", "IconBracketsContain", [["path", { "d": "M7 4h-4v16h4", "key": "svg-0" }], ["path", { "d": "M17 4h4v16h-4", "key": "svg-1" }], ["path", { "d": "M8 16h.01", "key": "svg-2" }], ["path", { "d": "M12 16h.01", "key": "svg-3" }], ["path", { "d": "M16 16h.01", "key": "svg-4" }]]);

export { IconBracketsContain as default };
//# sourceMappingURL=IconBracketsContain.mjs.map
